	            <footer class="footer border-top">
	                  <span>Postlogin footer</span>
                      <nav class="float-left">
                         <ul class="list-unstyled">
                            <li>

                            <a href="">{{ 'PreLogInFooter.Facebook.Name' | translate }}</a>

                            </li>
                            <li>

                            <a href="">{{ 'PreLogInFooter.Twitter.Name' | translate }}</a>

                            </li>
                            <li>

                            <a href="">{{ 'PreLogInFooter.LinkedIn.Name' | translate }}</a>

                            </li>
                         </ul>
                      </nav>
                      <div class="copyright float-right">
                        <span>
                             &copy; <script>document.write(new Date().getFullYear())</script>
                        </span>
                        
                      </div>
                </footer>